import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

export const getHeader = (state: RootState) => state.header;

export const getPageNameHeader = createSelector([getHeader], (header) => header.pageName);
export const getOnSiteHeader = createSelector([getHeader], (header) => header.onSite);
